import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { StateService } from '@uirouter/angular';
import { NgbModal, ModalDismissReasons, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ApiService } from '../../services/api.service';
import { FrontEndService } from '../../services/front-end.service';
import { DataService } from "../../services/data.service";
import swal from "sweetalert2";
import { AuthService, FacebookLoginProvider } from 'ng4-social-login';
import { SocialUser } from 'ng4-social-login';
import { LogService } from '../../services/log.service';

declare let hello: any;

@Component({
  selector: 'app-login-popup',
  templateUrl: './login-popup.component.html',
  styleUrls: ['./login-popup.component.scss']
})



export class LoginPopupComponent implements OnInit {

  loading = false;
  closeResult: any;
  activeTab = 'login';
  user_error = '';
  password_error = '';
  countries = [];
  searchCountry = "";
  public onlineOffline: boolean = navigator.onLine;
  loginForm = {};
  signForm = {};
  modalRef: NgbModalRef;
  showCaps = false;
  user: SocialUser;
  loggedIn: boolean;
  fbSignUp = {};

  @ViewChild("loginModalContent") private loginModalContent: ElementRef;

  constructor(
    private modalService: NgbModal,
    private apiService: ApiService,
    private stateService: StateService,
    private frontEndService: FrontEndService,
    private dataService: DataService,
    private authService: AuthService,
    private logService: LogService
  ) { }
  ngOnInit() {
    this.countries = this.dataService.countriesList;

    this.authService.authState.subscribe((user) => {
      this.user = user;
      this.loggedIn = (user != null);
      // this.logService.printLog("user -", this.user);


      // this.logService.printLog("logged -", this.loggedIn);
      // if (this.loggedIn) {
      //   this.signForm['email'] = this.user.email;
      //   this.signForm['password'] = this.user.token;
      //   this.signForm['confirm_password'] = this.user.token;
      //   this.signForm['phoneNumber'] = 9874466522;
      //   this.dataService.selectCountryDial = '91';
      //   this.onSignupSubmit();
      // }


    });
  }



  /* Start Facebook login*/
  // signInWithFB(): void {
  //   // this.loading = true;
  //   this.authService.signIn(FacebookLoginProvider.PROVIDER_ID)
  //   // this.loading = false;
  //     .then((response => {
  //       // this.logService.printLog(response);
  //       this.signForm['email'] = response.email;
  //       this.signForm['password'] = response.id;
  //       this.signForm['confirm_password'] = response.id;
  //       this.signForm['emailVerified'] = true;
  //       // this.signForm['phoneNumber'] = "";
  //       // this.dataService.selectCountryDial = '';
  //       this.signForm['fb'] = true;
  //       this.onSignupSubmit();
  //       // if(response['message'] == "This email already has been used.") {
  //       //   this.frontEndService.addToast('Info', 'Please login your account is already exist', 'info');
  //       //   this.signForm['email'] = '';
  //       //   this.signForm['password'] = '';
  //       //   this.signForm['confirm_password'] = '';
  //       //   this.signForm['phoneNumber'] = '';
  //       //   this.dataService.selectCountryDial = '';
  //       //   this.logService.printLog("this email is already used pls sign in with different email");
  //       // }
  //     }));
  // }

  loginWithFb(): void {
    this.authService.signIn(FacebookLoginProvider.PROVIDER_ID)
      .then((response => {
        const loginObject = {
          'email': response.email,
          'fb_id': response.id,
          'name': response.name,
        }
        this.apiService.facebookLogin(loginObject, (response) => {
          console.log("facebook response", response);
          if (response.response == "ok") {
            localStorage.setItem('user', JSON.stringify(response));
            this.closeModal();
            this.stateService.go('dashboard');
          } else {
            console.log("error", response);
          }
        });
      }))

  }
  /* End Facebook login*/


  signOut(): void {
    this.authService.signOut();
  }

  /* Twitter login */
  signInWithTwitter() {
    this.loading = true;
    this.apiService.twitterRequestToken();
  }

  showPassword = (input: any): any => {
    // this.logService.printLog("check ",input.nextSibling.nextSibling.classList)
    const picon = document.querySelector('.picon');
    if (input.nextSibling.nextSibling.classList.contains('fa-eye-slash')) {
      input.type = input.type === 'password' ? 'text' : 'text';
      input.nextSibling.nextSibling.classList.add('fa-eye');
      input.nextSibling.nextSibling.classList.remove('fa-eye-slash');
    } else {
      input.type = input.type === 'password' ? 'text' : 'password';
      input.nextSibling.nextSibling.classList.remove('fa-eye');
      input.nextSibling.nextSibling.classList.add('fa-eye-slash');
    }
  }

  capsLock(e) {
    var kc = e.keyCode ? e.keyCode : e.which;
    var sk = e.shiftKey ? e.shiftKey : ((kc == 16) ? true : false);
    if (((kc >= 65 && kc <= 90) && !sk) || ((kc >= 97 && kc <= 122) && sk))
      this.showCaps = true;
    else
      this.showCaps = false;
  }

  onSubmit(loginObject = null) {
    // this.logService.printLog("Login form data", this.loginForm);
    if (loginObject === null) {
      loginObject = this.loginForm;
    }
    this.loading = true;
    this.apiService.login(loginObject, (response) => {
      if (response['response'].toLowerCase() === 'ok') {
        this.loading = false;
        localStorage.setItem('user', JSON.stringify(response));
        localStorage.setItem('remember', JSON.stringify(loginObject['remember']));
        // this.logService.printLog(response);
        // this.logService.printLog('user response', response.response);
        this.closeModal();
        this.dataService.getLoginUserDetails();
        this.dataService.menuOptions();
        this.stateService.go('dashboard');
        // this.frontEndService.addToast('Success', response['message'], 'success');
      } else {
        this.user_error = response['message'];
        this.loading = false;
      }
    });
  }

  onSignupSubmit() {
    // this.logService.printLog('sign form data', this.signForm);
    this.signForm['countryCode'] = this.dataService.selectCountryDial;
    this.loading = true;
    if (this.signForm['password'] === this.signForm['confirm_password']) {
      this.apiService.signup(this.signForm, (response) => {
        this.loading = false;
        this.logService.printLog('signup response -', response);
        if (response.response == "ok") {
          this.loading = false;
          // this.logService.printLog("sign form -", this.signForm);
          this.loginForm['username'] = this.signForm['email'];
          this.loginForm['password'] = this.signForm['password'];
          this.onSubmit();
          this.frontEndService.addToast('Success', response['message'], 'info');
          // this.activeTab = 'login';
          this.signForm = {};
          this.loginForm = {};
          this.closeModal();
          // this.stateService.go('profile');
        } else if (this.signForm['fb']) {
          this.loading = false;
          this.frontEndService.addToast('Info', 'This email already exists, please login to continue.', 'info');
          this.dataService.selectCountryDial = '';
          this.signForm = {};
        } else {
          this.loading = false;
          this.frontEndService.addToast('Error', response['message'], 'error');
        }
      });
    } else {
      this.password_error = 'Passwords did not match';
      this.loading = false;
      // this.logService.printLog('not correct');
    }
    // alert('sign form data'+ JSON.stringify(this.signForm));
  }

  closeModal() {
    // this.logService.printLog("Closing modal");
    this.modalRef.close('Logged in');
    // document.querySelector('body').classList.add('modal-open');
    this.signForm = {};
  }

  openModal(type) {
    this.activeTab = type;
    this.open();
  }

  open() {
    this.modalRef = this.modalService.open(this.loginModalContent);
    // this.logService.printLog("Right modal opened");
    this.modalRef.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      this.signForm = {};
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  private filterCountries = () => {
    setTimeout(() => {
      // this.logService.printLog("Searched country - ", this.searchCountry);
      // this.logService.printLog("Countries filtered list - ", this.countries);
      if (this.searchCountry !== "") {
        this.countries = this.dataService.countriesList.filter(country =>
          country.name.toLowerCase().startsWith(this.searchCountry.toLowerCase())
        );
      } else {
        this.countries = this.dataService.countriesList;
      }
    }, 200);
  }
}




// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/landing_page/src/app/components/login-popup/login-popup.component.ts